<template>
    <div>
        <haederTrial ref="headers"></haederTrial>
        <div class="user">
            <div class="flex justify-between align-center">
                <div class="tab">
                    <div class="flex fd align-center" @click="typeTab(index)" style="margin-right: 60px;"
                        v-for="(item, index) in tabList2" :key="index">
                        <a class="tab2-item" :style="{ color: activeIndex == index ? '#3D82F6' : '#838B93' }"
                            style="cursor:pointer">{{
                                item.label }}</a>
                        <div v-if="activeIndex == index" class="active2-line"></div>
                    </div>
                </div>
                <div>
                    <el-input placeholder="请输入你要搜索的内容" v-model="formData.keyword" clearable class="input-with-select">
                        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </div>

            </div>
            <div class="line-fenjie">

            </div>
            <div v-loading="loading" class="a-content flex" style="min-height: 40vh;">
                <div class="a-content-item flex" v-for="(item, index) in dataList" :key="index"
                    @click="detail(item.reportId, item.type)">
                    <img class="a-content-img" :src="item.coverUrl" />
                    <div class="a-content-con">
                        <div class="a-content-title">
                            {{ item.title }}
                        </div>
                        <div class="a-content-text">
                            {{ item.introduction }}
                        </div>
                        <div class="a-content-price">￥<span style="font-size: 20px;font-weight: 600;">{{ item.webPrice
                        }}</span>
                        </div>
                    </div>
                </div>
                <div class="flex justify-content" style="width: 100%;">
                    <el-empty v-if="dataList.length == 0" :image-size="200"></el-empty>
                </div>
                <div v-if="dataList.length > 0" class="flex justify-content pagination"
                    style="width: 100%;margin-top: 57px;">
                    <el-pagination background layout="prev, pager, next" :page-size="10" @current-change="changePage"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <footers></footers>
    </div>
</template>
<script>
import footers from '@/components/footer.vue'
import haederTrial from '../../components/haeder-trial.vue'
export default {
    components: { haederTrial, footers },
    data() {
        return {
            tabList2: [{
                url: '',
                label: '我的报告'
            }, {
                url: '',
                label: '我的收藏'
            }],
            formData: {
                userId: this.$store.state.userId,
                page: 1,
                limit: 10,
                keyword: ''
            },
            tabIndex: 3,
            activeIndex: 0,
            title: '',
            loading: false,
            dataList: [],
            total: 0
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            let that = this
            if (that.activeIndex == 0) {
                this.loading = true
                that.apis.buyReport(this.formData).then(res => {
                    this.loading = false
                    that.total = res.count
                    that.dataList = res.data
                })
            } else {
                this.loading = true
                that.apis.collectReport(this.formData).then(res => {
                    this.loading = false
                    that.total = res.count
                    that.dataList = res.data
                })
            }
        },
        typeTab(e) {
            this.activeIndex = e
            this.formData.page = 1
            this.formData.limit = 10
            this.loadData()
        },
        // 分页
        changePage(e) {
            this.formData.page = e
            this.loadData()
        },
        // 搜索
        search() {
            this.loadData()
        },
        // 详情
        detail(id, type) {
            if (this.$store.state.userId) {
                let routeUrl = this.$router.resolve({
                    path: "/detail",
                    query: { id: id, type: type },
                });
                window.open(routeUrl.href);
            } else {
                this.$emit('loginStatus', true)
            }

        },
    }
}
</script>
<style>
.user {
    width: 1200px;
    margin: 0 auto;
    margin-top: 138px;
    margin-bottom: 51px;
    /* min-height: 50vh; */
    position: relative;
}

.user .line-fenjie {
    width: 100%;
    height: 0px;
    opacity: 1;
    border: 1px solid #ecf1f5;
    margin: 8px 0 20px 0;
}

.user .pagination {
    /* position: relative;
    bottom: 0; */
}

.user .a-content {
    margin: 24px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.user .a-content-item {
    width: 588px;
    height: 119px;
    background: #ffffff;
    opacity: 1;
    border: 1px solid #f1f3f7;
    border-radius: 6px;
    margin-bottom: 25px;
    align-items: center;
    cursor: pointer;
}

.user .a-content-img {
    width: 210px;
    height: 119px;
    opacity: 1;
    border-radius: 6px 0 0 6px;
}

.user .a-content-title {
    width: 299px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user .a-content-con {
    margin: 12px 6px 11px 16px;
}

.user .a-content-text {
    width: 354px;
    /* height: 64px; */
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #838b93;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 4px;
    margin-bottom: 8px;
}

.a-content-price {
    font-size: 12px;
    color: #297FFF;
}

.is-put {
    position: absolute;
    top: -2px;
    left: -2px;
    width: 74px;
    height: 44px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/index.vue